import React from "react";
import MySkeleton from "components/ui/feedback/Skeleton";
import { useStatsFetch } from "./useStatsApi";
import {
  StatCard,
  SectionCard,
  RefreshButton,
  ErrorMessage,
  Badge,
  formatNumber,
} from "./StatComponents";

const numCell = { padding: "8px 10px", borderBottom: "1px solid #eee", textAlign: "right" };

const AppVersionStats = () => {
  const { data, isLoading, error, load } = useStatsFetch("/admin/statistics/app-versions");

  const summary = data?.summary;
  const versions = data?.versions || [];
  const outdated = summary?.outdatedUsers;
  const totalOutdatedUsers = outdated
    ? outdated.parents + outdated.personel + outdated.drivers + outdated.admins + outdated.other
    : 0;

  return (
    <SectionCard
      title={
        summary?.latestVersion
          ? `Uygulama Sürüm Dağılımı (Görülen son sürüm: ${summary.latestVersion})`
          : "Uygulama Sürüm Dağılımı"
      }
      actions={<RefreshButton onClick={() => load()} isLoading={isLoading} />}
    >
      <ErrorMessage message={error} />

      {isLoading && !data ? (
        <MySkeleton lineCount={6} />
      ) : data ? (
        <>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "15px", marginBottom: "20px" }}>
            <StatCard label="Görülen Son Sürüm" value={summary.latestVersion || "-"} color="#2e7d32" />
            <StatCard
              label="Son Sürümde"
              value={summary.devicesOnLatest}
              sub={
                summary.totalDevices > 0
                  ? ((summary.devicesOnLatest / summary.totalDevices) * 100).toFixed(1) + "% cihaz"
                  : null
              }
              color="#43a047"
            />
            <StatCard
              label="Eski Sürümde"
              value={summary.devicesOutdated}
              sub={
                summary.totalDevices > 0
                  ? ((summary.devicesOutdated / summary.totalDevices) * 100).toFixed(1) + "% cihaz"
                  : null
              }
              color="#e53935"
            />
            <StatCard
              label="Sürümü Bilinmeyen"
              value={summary.devicesUnknown}
              sub="appVersion bilgisi olmayan cihazlar"
              color="#9e9e9e"
            />
          </div>

          <h4 style={{ margin: "0 0 10px 0", fontSize: "14px" }}>
            Eski Sürümde Kalan Kullanıcılar ({formatNumber(totalOutdatedUsers)} kullanıcı)
          </h4>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "15px", marginBottom: "20px" }}>
            <StatCard label="Veli" value={outdated?.parents} color="#7b1fa2" />
            <StatCard label="Personel" value={outdated?.personel} color="#8e24aa" />
            <StatCard label="Sürücü" value={outdated?.drivers} color="#ef6c00" />
            <StatCard label="Admin" value={outdated?.admins} color="#546e7a" />
            <StatCard label="Diğer" value={outdated?.other} color="#9e9e9e" />
            <StatCard
              label="Eşleşmeyen Cihaz"
              value={summary.outdatedUnmatchedDevices}
              sub="Telefonu hiçbir kullanıcıyla eşleşmeyen"
              color="#bdbdbd"
            />
          </div>

          <h4 style={{ margin: "0 0 10px 0", fontSize: "14px" }}>Sürüm Bazında Kırılım</h4>
          <div style={{ overflowX: "auto", maxHeight: "500px", overflowY: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "14px" }}>
              <thead>
                <tr style={{ background: "#f5f5f5" }}>
                  <th style={{ padding: "10px", textAlign: "left", borderBottom: "2px solid #ddd" }}>Sürüm</th>
                  <th style={{ padding: "10px", textAlign: "right", borderBottom: "2px solid #ddd" }}>Cihaz</th>
                  <th style={{ padding: "10px", textAlign: "right", borderBottom: "2px solid #ddd" }}>Veli</th>
                  <th style={{ padding: "10px", textAlign: "right", borderBottom: "2px solid #ddd" }}>Personel</th>
                  <th style={{ padding: "10px", textAlign: "right", borderBottom: "2px solid #ddd" }}>Sürücü</th>
                  <th style={{ padding: "10px", textAlign: "right", borderBottom: "2px solid #ddd" }}>Admin</th>
                  <th style={{ padding: "10px", textAlign: "right", borderBottom: "2px solid #ddd" }}>Diğer</th>
                  <th style={{ padding: "10px", textAlign: "right", borderBottom: "2px solid #ddd" }}>Eşleşmeyen</th>
                  <th style={{ padding: "10px", textAlign: "right", borderBottom: "2px solid #ddd" }}>Cihaz Oranı</th>
                </tr>
              </thead>
              <tbody>
                {versions.map((v) => (
                  <tr key={v.version} style={{ background: v.isLatest ? "#e8f5e9" : "transparent" }}>
                    <td style={{ padding: "8px 10px", borderBottom: "1px solid #eee", fontWeight: 500 }}>
                      {v.version === "unknown" ? "Bilinmeyen" : v.version}{" "}
                      {v.isLatest && (
                        <Badge color="#c8e6c9" textColor="#1b5e20">
                          Güncel
                        </Badge>
                      )}
                    </td>
                    <td style={numCell}>{formatNumber(v.devices)}</td>
                    <td style={numCell}>{formatNumber(v.users?.parents)}</td>
                    <td style={numCell}>{formatNumber(v.users?.personel)}</td>
                    <td style={numCell}>{formatNumber(v.users?.drivers)}</td>
                    <td style={numCell}>{formatNumber(v.users?.admins)}</td>
                    <td style={numCell}>{formatNumber(v.users?.other)}</td>
                    <td style={numCell}>{formatNumber(v.unmatchedDevices)}</td>
                    <td style={numCell}>
                      {summary.totalDevices > 0 ? ((v.devices / summary.totalDevices) * 100).toFixed(1) + "%" : "-"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      ) : null}
    </SectionCard>
  );
};

export default AppVersionStats;
